import moment from 'moment';

export const DEFAULT_FORMAT = 'YYYY-MM-DD';
export const ISO_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
export const YEAR_MONTH = 'MM-YYYY';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const FULL_DATE_FORMAT = 'MMMM DD YYYY';
export const FULL_MONTH_FORMAT = 'MMMM YYYY';

export function getDateToday() {
    return moment();
}

export function getDateTodayIsoFormat() {
    return moment().format(ISO_FORMAT);
}

export function getPastDay(numberOfDays: number) {
    return moment().subtract(numberOfDays, 'd').format(ISO_FORMAT);
}

export function getStartOfCurrentMonth() {
    return moment().startOf('month').format(ISO_FORMAT);
}

export function getEndOfCurrentMonth() {
    return moment().endOf('month').format(ISO_FORMAT);
}

export function getMonth(date: Date | string | null | undefined) {
    if (date) {
        return moment(date).format('MM');
    }
    return moment().format('MM');
}

export function getYear(date: Date | string | null | undefined) {
    if (date) {
        return moment(date).format('YYYY');
    }
    return moment().format('YYYY');
}

export function formatDate(date: Date | string, dateFormat: string = DEFAULT_FORMAT) {
    return moment.utc(date).format(dateFormat);
}

export function formatDateTime(date: Date | string) {
    return moment.utc(date).format(DATE_TIME_FORMAT);
}

export function formatDateToIso(date: Date | string) {
    return moment.utc(date).format(ISO_FORMAT);
}

export function formatYearMonth(date: Date | string) {
    return moment(date).format(YEAR_MONTH);
}

export function parseStringToDate(date: string) {
    return moment(date);
}

export function subtractMonthsFromDate(numberToMinus: number, date: Date | string | null | undefined = getDateTodayIsoFormat()) {
    if (date) {
        return moment(date).subtract(numberToMinus, 'months').format(ISO_FORMAT);
    }

    return moment().subtract(numberToMinus, 'months').format(ISO_FORMAT);
}

export function getEndDayOfDate(date: Date | string | null | undefined = getDateTodayIsoFormat()) {
    if (date) {
        const endDate = moment(date).endOf('month').format(DEFAULT_FORMAT);
        return formatDateToIso(endDate);
    }
    return moment().endOf('month').format(ISO_FORMAT);
}

export function getStartDayOfDate(date: Date | string | null | undefined = getDateTodayIsoFormat()) {
    if (date) {
        const startDate = moment(date).startOf('month').format(DEFAULT_FORMAT);
        return formatDateToIso(startDate);
    }
    return moment().startOf('month').format(ISO_FORMAT);
}

export function changeMomentLocale(locale: string) {
    if (locale === 'en') {
        moment.locale('en');
    } else {
        moment.locale('ja');
    }
}

export function formatDateWithLang(date: Date | string, dateFormat: string = DEFAULT_FORMAT, locale: string) {
    if (locale === 'en') {
        moment.locale('en');
    } else {
        moment.locale('ja');
    }
    moment.locale('ja');
    return moment.utc(date).format(dateFormat);
}
